import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ActivityDetailsResultDto } from "src/app/_models/ActivityDetailResultDto";
import { CourseContentMetadataActionTypes } from "src/app/constants/StoreConstants";


export const GetActivityDetails = createAction(
  CourseContentMetadataActionTypes.GetActivityDetails,
  props<{objectId: string}>()
);

export const GetActivityDetailsSuccess = createAction(
  CourseContentMetadataActionTypes.GetActivityDetailsSuccess,
  props<{result: ActivityDetailsResultDto}>()
);

export const GetActivityDetailsError = createAction(
  CourseContentMetadataActionTypes.GetActivityDetailsError,
  props<{error: HttpErrorResponse}>()
);

export const GetResourceDetails = createAction(
  CourseContentMetadataActionTypes.GetResourceDetails,
  props<{objectId: string, courseId: number}>()
);

export const GetResourceDetailsSuccess = createAction(
  CourseContentMetadataActionTypes.GetResourceDetailsSuccess,
  props<{result: ActivityDetailsResultDto}>()
);

export const GetResourceDetailsError = createAction(
  CourseContentMetadataActionTypes.GetResourceDetailsError,
  props<{error: HttpErrorResponse}>()
);